const translations = {
    copyError: 'Unable to copy selection'
};

export default translations;
